import { ICompany, IAppInfo, IUserInfo } from 'kts-platform-frame/dataModel';

/**
 * 用户数据节点
 */
export default class Node {

    /** 用户数据 */
    public userInfo: IUserInfo = {} as IUserInfo;

    /** 账号 */
    public account: string = null;

    /** 公司列表 */
    public companyList: ICompany[] = [];

    /** 当前公司ID */
    public currentcompanyId: string = null;

    /** 已经安装的appList */
    // public appList: IAppInfo[] = [];

    /** 用户的全局token */
    public gToken: string;

    /** 用户的公司token */
    public cToken: string;

    /** 三条腿token */
    public aToken: string;

    /** 公司接口头 */
    public zoneUrl: string;
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/user/Node.ts